import React, { FC } from 'react';
import {
  CapabilityDTO,
  CapabilityDTOFromJSON,
  SearchResultDTOTypeEnum,
  SloDTO,
  SloDTOFromJSON,
} from '@atlassiansox/phobos-client-ts';

import { CapabilityTier } from '@/components/primitive';
import SloTypeLozenge from '@/components/composed/slo-card/lozenges/slo-type-lozenge';
import { isIndicatorTypeMimir } from '@/components/composed/slo-group/utils';

import { SearchResultItemType } from '../types';

import * as styles from './styles';
import SearchKeyValueTag from './search-key-value-tag';

type SearchListInfoProps = {
  item: SearchResultItemType;
  type: SearchResultDTOTypeEnum;
};

const SearchListInfo: FC<SearchListInfoProps> = ({ item, type }) => {
  let displayElement = <></>;

  switch (type) {
    case SearchResultDTOTypeEnum.SloGroup: {
      const slo: SloDTO = SloDTOFromJSON(item);
      const isMimir = isIndicatorTypeMimir((item as SloDTO).indicator);

      displayElement = (
        <div css={[styles.searchResultColumnStyles, styles.searchResultTagColumnStyles]}>
          <SloTypeLozenge type={slo.type} isCompact isMimir={isMimir} />
        </div>
      );
      break;
    }
    case SearchResultDTOTypeEnum.Slo: {
      const slo: SloDTO = SloDTOFromJSON(item);

      displayElement = (
        <div css={[styles.searchResultColumnStyles, styles.searchResultTagColumnStyles]}>
          <SloTypeLozenge type={slo.type} isCompact />
        </div>
      );
      break;
    }
    case SearchResultDTOTypeEnum.Capability: {
      const capability: CapabilityDTO = CapabilityDTOFromJSON(item);
      const { importance } = capability;

      displayElement = (
        <SearchKeyValueTag title="capability tier">
          <CapabilityTier tier={importance} />
        </SearchKeyValueTag>
      );
      break;
    }
    case SearchResultDTOTypeEnum.Team: {
      break;
    }
    case SearchResultDTOTypeEnum.Product: {
      break;
    }
  }

  return <div css={styles.searchResultColumnStyles}>{displayElement}</div>;
};

export default SearchListInfo;
